import axios from "axios";
import Cookies from "js-cookie";
import { normalizeClientServiceInterval } from "../../helpers/intervalTypesMap";
import { FIRMFLOWURL } from "../url";
export const updateClientService = (clientSubscriptionId, form) => {
  return new Promise(async (resolve) => {
    try {
      const token = Cookies.get("Bearer");
      const payload = { ...form };
      delete payload.isEfileStatusActive;
      ["interval", "intervalType", "clientServiceSubscriptionIntervalType"].forEach(
        (field) => {
          if (typeof payload[field] === "string") {
            payload[field] = normalizeClientServiceInterval(payload[field]);
          }
        }
      );
      const response = await axios.put(
        `${FIRMFLOWURL}api/ClientSubscription/${clientSubscriptionId}/update`,
        payload,
        {
          headers: { Authorization: token },
        }
      );
      resolve({ ...response, success: true });
    } catch (err) {
      console.log(err);
      if (err.message.includes(401)) {
        Cookies.remove("Bearer");
        window.location.replace("/");
        return;
      }
      resolve({ success: false, message: err.response.data.message });
    }
  });
};
